import { useState } from "react";
import { Box, Dialog, DialogTitle, DialogContent, Grid, Stack, Button, Paper } from "@mui/material";

import AssetTypeDistribution from "./AssetTypeDistribution";
import AssetTypeDetails from "./AssetTypeDetails";
import AssetTypeAllocation from "./AssetTypeAllocation";
import NextAssetCard from "./NextAssetCard";
import NextAssetFull from "./NextAssetFull";

import CloseIcon 			from '@mui/icons-material/Close';

import usePortfolioAllocations from "../hooks/usePortfolioAllocations";

const TabGeneral = () => {
	const {
		selectedClass,
		setSelectedClass,
		targetAllocations,
		setTargetAllocations,
		fullPortfolio,
		investablePortfolio,
		selectedPortfolio,
		guidanceMap,
		investByDate,
		remainingTarget,
		saveAssetAllocations
	} = usePortfolioAllocations()

	const [dialogOpen, setDialogOpen]						= useState(false)
	const [isSavingAllocations, setIsSavingAllocations]		= useState(false)

	const handleSave = async () => {
		setIsSavingAllocations(true)
		
		try {
			await saveAssetAllocations()
		} 
		finally {
			setIsSavingAllocations(false)
		}
	}

	return (
		<Box paddingY={2} paddingX={1.5} sx={{ height: '100%' }}>
			<Grid container spacing={2} sx={{ height: '100%' }}>
				<Grid item xs={12} md={4} sx={{ height: '100%' }}>
					<Paper elevation={1} sx={{ padding: 1.5, boxSizing: 'border-box' }}>
						<AssetTypeDistribution
							allocations={targetAllocations}
							selectedClass={selectedClass}
							setSelectedClass={setSelectedClass}
						/>
					</Paper>
				</Grid>

				<Grid item xs={12} md={4} sx={{ height: '100%' }}>
					<Paper elevation={1} sx={{ padding: 1.5, height: '100%', boxSizing: 'border-box' }}>
						<AssetTypeDetails data={selectedPortfolio}/>
					</Paper>
				</Grid>

				<Grid item xs={12} md={4} sx={{ height: '100%' }}>
					<Stack direction="column" justifyContent="space-between" alignItems="center" marginBottom={1} width={'100%'} spacing={2}>
						<Paper elevation={1} sx={{ padding: 1.5, width: '100%', boxSizing: 'border-box' }}>
							<NextAssetCard
								allocations={targetAllocations}
								portfolio={investablePortfolio}
								guidanceMap={guidanceMap}
								investByDate={investByDate}
							/>
							<Box mt={2} display="flex" justifyContent="center">
								<Button variant="contained" size="small" onClick={() => setDialogOpen(true)}>
									Ver lista completa
								</Button>
							</Box>
						</Paper>
					
						<Paper elevation={1} sx={{ padding: 1.5, width: '100%', boxSizing: 'border-box' }}>
							<AssetTypeAllocation
								allocations={targetAllocations}
								onUpdate={setTargetAllocations}
								remainingTarget={remainingTarget}
								onSave={handleSave}
								isSaving={isSavingAllocations}
								size={'small'}
							/>
						</Paper>
					</Stack>
				</Grid>
			</Grid>
			<Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} fullWidth maxWidth="sm">
				<DialogTitle display={'flex'}>
					<Box flex={1}>Próximos ativos a aportar</Box>
					<CloseIcon onClick={() => setDialogOpen(false)} sx={{cursor: 'pointer'}}/>
				</DialogTitle>
				
				<DialogContent>
					<NextAssetFull
						allocations={targetAllocations}
						portfolio={fullPortfolio}
						guidanceMap={guidanceMap}
						investByDate={investByDate}
					/>
				</DialogContent>
			</Dialog>
		</Box>
	)
}

export default TabGeneral
